<template>
  <div class="col-12 col-lg-3 d-flex d-lg-block mb-4 mb-lg-0">

    <div class="sidebar item me-auto mb-4">
      <img :src="`/storage/${item.image}`" class="card-img-top" :alt="item.title">
      <div class="card pe-3">

        <div class="card-body">
          <h5 class="card-title mb-4">{{ item.title }}</h5>

          <div class="row">
            <div class="col-12" v-html="item.description">
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="d-block">
      <div class="sidebar sidebar-content mb-4">
        <p class="mb-0 fst-italic"> Eenheid </p>
        <h2 class="display-4  mb-4" v-if="item"> {{ getUnitLabel(item.unit) }}</h2>
      </div>

      <div class="sidebar sidebar-content mb-4" v-if="controls">
        <button class="btn btn-primary me-2 mb-2" @click="clock(item.id,'start')">Start</button>
        <button class="btn btn-primary me-2 mb-2" @click="clock(item.id,'stop')">Pauze</button>
        <button class="btn btn-primary me-2 mb-2" @click="clock(item.id,'restart')">Reset</button>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    controls: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      units: {
        '0.01': 'Eurocent',
        '0.10': '10 Eurocent',
        '0.25': '25 Eurocent',
        '1.00': '1 Euro',
        '10.00': '10 Euro',
        '100.00': '100 Euro',
      },
    };
  },
  methods: {
    clock(id, status) {
      let uri = '/api/auction/' + this.item.auction_id + '/item/' +  id +'/' + status
      this.axiosRequest(uri, 'POST', function (){})
    },
    getUnitLabel(key) {
      if (typeof (key) !== 'undefined' || key !== null) {
        return this.units[key]
      }
    },
    axiosRequest(uri, method, callback)
    {
      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

      axios({
        method: method,
        url: uri,
        data: {'X-CSRF-TOKEN': csrfToken},
      })
          .then(response => {
            if (
                response.data.status &&
                response.data.status == 'success') {
              callback;
            }
          });
    }
  }

}
</script>
